/** Histogramme des vues par jour (SVG simple, regroupé par semaine au-delà de 90 jours). */
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { formatDate, formatNumber } from '../utils/format'

export function ViewsChart({ points }: { points: { day: string; count: number }[] }) {
  const { t } = useTranslation('gestion')
  const bars = useMemo(() => {
    if (points.length <= 90) return points.map((p) => ({ label: p.day, count: p.count }))
    const weeks: { label: string; count: number }[] = []
    for (let i = 0; i < points.length; i += 7) {
      const chunk = points.slice(i, i + 7)
      weeks.push({ label: chunk[0].day, count: chunk.reduce((s, p) => s + p.count, 0) })
    }
    return weeks
  }, [points])
  const max = Math.max(1, ...bars.map((b) => b.count))
  const total = bars.reduce((s, b) => s + b.count, 0)
  const w = 100 / bars.length

  if (total === 0) {
    return (
      <div className="g-chart g-chart--empty">
        <span className="mdi mdi-chart-bar g-empty__icon" aria-hidden />
        <p className="g-muted">{t('tableau.aucune_vue')}</p>
      </div>
    )
  }

  return (
    <div className="g-chart">
      <svg viewBox="0 0 100 40" preserveAspectRatio="none" role="img" aria-label={t('tableau.vues_par_jour')}>
        {bars.map((b, i) => {
          const h = (b.count / max) * 38
          return (
            <rect key={b.label} x={i * w + w * 0.12} y={40 - h} width={w * 0.76} height={h} rx={0.4} className="g-chart__bar">
              <title>{`${formatDate(b.label)} : ${formatNumber(b.count)}`}</title>
            </rect>
          )
        })}
      </svg>
      <div className="g-chart__axis">
        <span>{formatDate(bars[0].label)}</span>
        <span>{t('tableau.max_par_jour', { n: formatNumber(max) })}</span>
        <span>{formatDate(bars[bars.length - 1].label)}</span>
      </div>
    </div>
  )
}
